// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "@/store";
import bus from "@/utils/bus";
import apis from "@/apis";

import Vant from "vant";
import 'vant/lib/index.css';
import "animate.css";
import { } from "./assets/fonts/iconfont";
import './assets/fonts/iconfont.css';
// import tap from "@/directives/tap";
// import clickoutside from "@/directives/clickoutside";
import {
  saveToLocal,
  loadFromLocal,
  removeFromLocal
} from "@/utils/localStorage";
import {
  saveToSession
} from "@/utils/sessionStorage";
// import VueAsset from 'asset-web-support'
import vmaAssist from "vma-vue-assist";
import config from "@/config";
// import wxShare from "@/utils/wxShare";
import {
  Toast
} from "vant";
import VeeValidate, {
  Validator
} from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN"; // 引入中
import ganToast from '@/components/loading'
import VueClipboard from 'vue-clipboard2'
import VueJsonp from 'vue-jsonp'
// import directive from "@/directive/index";
// import filters from "@/filters/index";
import * as veeRules from "@/utils/veeRules";
import intelligentCookie from 'vue-intelligent-cookie'
import { IsPC } from "@/utils";
import vConsole from '@/utils/vconsole'
import { initWxInterface } from '@/utils/wxShare'

const MetaInfo = require("vue-meta-info");
Vue.use(MetaInfo);

let vm = new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});

window.$vm = vm;

const env = process.env.NODE_ENV
Vue.use(intelligentCookie);
Vue.use(VueClipboard)
Vue.use(VueJsonp)
Validator.addLocale(zh_CN);
const veeConfig = {
  errorBagName: "errors", // change if property conflicts.
  delay: 0,
  locale: "zh_CN",
  messages: null,
  strict: true,
  // events: 'blur',
};
Vue.use(VeeValidate, veeConfig);
const dictionary = {
  zh_CN: {
    messages: {
      required: field => "请输入" + field,
    }
  }
};

Validator.updateDictionary(dictionary);

// sessionStorageClean

// localStorageClean

let ldata_gs_mall_session_id = loadFromLocal('gs_mall_session_id')
let ldata_gs_mall_userInfo = loadFromLocal('gs_mall_userInfo')
let ldata_searchAssist_hitoryLabels = loadFromLocal('searchAssist_hitoryLabels')
localStorage.clear();
saveToLocal('gs_mall_session_id', ldata_gs_mall_session_id);
saveToLocal('gs_mall_userInfo', ldata_gs_mall_userInfo);
saveToLocal('searchAssist_hitoryLabels', ldata_searchAssist_hitoryLabels);

store.dispatch("setUserInfo", ldata_gs_mall_userInfo);

Vue.use(Vant);
/**@augments 引入开始 */
//Vue.component(Loadmore.name, Loadmore);
/**@argument 全局注入过滤器 */
// Object.keys(filters).forEach(key => {
//   Vue.filter(key, filters[key]);
// });
Object.keys(veeRules).forEach(key => {
  Validator.extend(key, veeRules[key]);
});
// /**@argument 全局注入指令 */
// Object.keys(directive).forEach(key => {
//   Vue.directive(key, directive[key]);
// });
// /**@augments 引入结束 */



if (IsPC()) {
  console.log('In PC');
  // hide
  vConsole.hideSwitch()
} else {
  if (env == 'production') {
    // // hide
    if (ldata_gs_mall_userInfo && (ldata_gs_mall_userInfo.phone == '18149546567'||ldata_gs_mall_userInfo.phone == '18359191421')) {
      vConsole.showSwitch()
    } else {
      vConsole.hideSwitch()
    }
    console.log('In Mobile');
  } else {
    console.log('In Mobile');
    vConsole.showSwitch()
  }
}
let envInfo = { env, host: config.host, location };
console.log('Load main', { envInfo });

// urlClean
function queryURL(url) {
  var arr1 = url.split("?");
  var params = arr1[1].split("&");
  var obj = {}; // 声明对象
  for (var i = 0; i < params.length; i++) {
    var param = params[i].split("=");
    obj[param[0]] = param[1]; // 为对象赋值
  }
  return obj;
}

try {
  let href = location.href;
  let href_hash = "";
  let href_query = {};
  if (href.indexOf('/#/') > -1) {
    // href_hash = href.split('#/')[1].split('?')[0]
  } else {
    if (href.indexOf('#/') > -1) {
      href = href.split('#/')[0]
    }
  }
  if (href.indexOf('?') > -1) {
    href_query = queryURL(href);
  }
  if (href_query) {
    href_hash = href_query.hash;
    delete href_query.from;
    delete href_query.form;
    delete href_query.hash;
    if (href_hash) {
      let href_queryStr = [];
      for (const key in href_query) {
        if (href_query.hasOwnProperty(key)) {
          href_queryStr.push(`${key}=${href_query[key]}`);
        }
      }
      let newHref = `${location.origin}${href_hash ? '/#/' + href_hash : ''}${href_queryStr && href_queryStr.length ? '?' + href_queryStr.join('&') : ''}`
      let newHash = `${href_hash}${href_queryStr && href_queryStr.length ? '?' + href_queryStr.join('&') : ''}`
      router.replace({ path: newHash });
      console.log('==== urlClean ====', { oldHref: location.href, newHref, newHash });
      setTimeout(() => {
        location.href = newHref;
      }, 50);
    }
  }
} catch (error) {
  console.error(error);
}


Vue.use(vmaAssist, {
  plugins: {
    axios: {
      // 将extend到axios.defaults
      defaults: {
        baseURL: config.host,
        responseType: "text"
      },
      // 所有的拦截器只要配置为false则不启用
      interceptor: {
        // 全局错误拦截器
        authMac: {
          SESSION_ID: "session_id"
        },
        dataToUnderline: false,
        errorHandle: {
          handleError(error) {
            console.error(error)
            let strErrorMsg = '系统错误';
            if (error && error.response) {
              if (error.response.status == 401) {
                removeFromLocal("gs_mall_userInfo");
                intelligentCookie.remove("gs_mall_session_id");
                store.dispatch("setUserInfo", null);
                let isJump = true;
                if (error.request.responseURL.indexOf('member/setting') > -1 && vm && vm.$router && vm.$router.currentRoute && vm.$router.currentRoute.name == 'my') {
                  isJump = false;
                }
                if (isJump) {
                  saveToSession("login_target_page", {
                    name: vm.$router.currentRoute.name,
                    path: vm.$router.currentRoute.path,
                    query: vm.$router.currentRoute.query,
                    params: vm.$router.currentRoute.params,
                  });
                  router.push({
                    name: "login"
                  });
                }
              }
              if (error.response.data.message) {
                strErrorMsg = error.response.data.message;
              } else if (error.response.data.msg) {
                strErrorMsg = error.response.data.msg;
              }
            }
            let isToast = true;
            if (error.request.responseURL.indexOf('sign_package') > -1) {
              isToast = false;
            }
            if (error.request.responseURL.indexOf('member/setting') > -1 && vm && vm.$router && vm.$router.currentRoute && vm.$router.currentRoute.name == 'my') {
              isToast = false;
            }
            isToast && Toast.fail({
              message: strErrorMsg,
              duration: 2000
            });
          }
        },
        // http请求显示加载中
        loading: {
          // 第一个http请求发起时
          showLoader() {
            ganToast.loading({
              duration: 0
            });
            // Indicator.open();
          },
          // 最后一个http请求结束时
          hideLoader() {
            // console.log("hideloader");
            ganToast.clear();
            // Indicator.close();
          }
        },
        removeEmpty: true,
        returnResponseData: true
      }
    }
  }
});

// Vue.directive("tap", tap);
// Vue.directive("clickoutside", clickoutside);
Object.defineProperties(Vue.prototype, {
  $apis: {
    value: apis
  },
  // $bus: {
  //   value: bus
  // }
});
Vue.config.productionTip = false;

let $routerstack = [];
router.beforeEach((to, from, next) => {
  console.log('beforeEach', { to, from }, { toPath: to.path, fromPath: from.path }, location)
  if (to.name == 'orderList') {
    bus.$emit('reload')
  }
  /*页面级animated--begin*/
  let toName = getRouterHash(to);
  let fromName = getRouterHash(from);
  let direction = 'forward';
  store.dispatch("toName", toName);
  store.dispatch("fromName", fromName);
  if ($routerstack.length && $routerstack[$routerstack.length - 1] == toName) {
    direction = 'reverse';
    $routerstack.pop();
  } else {
    direction = 'forward';
    $routerstack.push(fromName);
  }

  store.dispatch("direction", direction);
  /*页面级animated--end*/

  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (!(toName.indexOf('serviceDetail') > -1)) {
    initWxInterface();
  }

  if (to.name === "login" || to.name === "weixinLoginValidate") {
    let userInfo = {};
    userInfo = store && store.getters && store.getters.userInfo;
    // userInfo = loadFromLocal('gs_mall_userInfo')
    if (userInfo && userInfo.phone) {
      // && userInfo.phone.search('6567') != -1
      next("/home");
      document.title = '福龄生活';
    } else {
      next();
    }
  } else {
    next();
  }
  // console.log('$routerstack', $routerstack)
});


function getRouterHash(router) {
  let Hash = router.name || router.path;
  if (Hash == 'diy_page' || Hash == 'pageH5') {
    Hash += router.params.id || router.query.id
  }
  return Hash;
}

setTimeout(() => {
  if (vm.$router && vm.$router.currentRoute) {
    let to = vm.$router.currentRoute
    if (to.meta.title && to.name != 'scanResult') {
      document.title = to.meta.title
    }
  }
}, 100);
initWxInterface();


// WEBPACK FOOTER //
// ./src/main.js